import { io } from 'socket.io-client';

// URL de producción fija - chatmanantial.com
const SOCKET_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:3000'
  : 'https://chatmanantial.com';

let socket = null;

export const initSocket = () => {
  if (!socket) {
    socket = io(SOCKET_URL, {
      autoConnect: false
    });
  }
  return socket;
};

export const connectSocket = (userId, departments = []) => {
  if (!socket) {
    initSocket();
  }

  socket.connect();

  // Unirse a sala personal
  socket.emit('join:user', userId);

  // Unirse a salas de departamentos
  departments.forEach(dept => {
    socket.emit('join:department', dept.department_id);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
  }
};

export const getSocket = () => socket;

// Eventos de chat
export const sendMessage = (departmentId, message) => {
  if (socket) {
    socket.emit('chat:message', { departmentId, ...message });
  }
};

export const onNewMessage = (callback) => {
  if (socket) {
    socket.on('chat:new_message', callback);
  }
};

export const offNewMessage = (callback) => {
  if (socket) {
    socket.off('chat:new_message', callback);
  }
};

// Eventos de tareas
export const onNewTask = (callback) => {
  if (socket) {
    socket.on('task:new', callback);
  }
};

// Eventos de incidencias
export const onIncidentUpdate = (callback) => {
  if (socket) {
    socket.on('incident:updated', callback);
  }
};

// Eventos de notificaciones
export const onNewNotification = (callback) => {
  if (socket) {
    socket.on('notification:new', callback);
  }
};

export const offNewNotification = (callback) => {
  if (socket) {
    socket.off('notification:new', callback);
  }
};

export default {
  initSocket,
  connectSocket,
  disconnectSocket,
  getSocket,
  sendMessage,
  onNewMessage,
  offNewMessage,
  onNewTask,
  onIncidentUpdate,
  onNewNotification,
  offNewNotification
};
